// extracted by mini-css-extract-plugin
export var pillWrapper = "_xo-0";
export var showOverflow = "_xo-1";